<template>
  <div>
    <div class="find_pwd">
      <p class="f_pwd_xuan">
        <span>パスワードの再発行</span>
      </p>
      <p class="p_pwd_xuan">
        <span><router-link to="/login"><img src="../../assets/images/users/Return.png"></router-link></span>
        <span>パスワードの再発行</span>
        <span></span>
      </p>
      <div class="find_pwd_input">
        <input type="text" name="find_email" v-model="find_email" placeholder="メールアドレス">
        <span v-show="errors.has('find_email')" class="error">{{ errors.first('find_email') }}</span>
        <span class="error">{{errMessage}}</span>
      </div>
      <p class="find_pwd_down">
        <button @click="mail_pwd">次へ</button>
      </p>
    </div>
  </div>
</template>

<script>
  import {vertifyCode, forgetPwd} from './../../api/interface/users'

  import VeeValidate, {Validator} from 'vee-validate'
  import cn from 'vee-validate/dist/locale/zh_CN'
  Validator.localize('cn', cn);
  const dict = {
    cn: {messages: {required: (name) => `${name}必要!`}}
  };
  Validator.localize(dict);
  export default{
    name: "",
    validator: null,
    data(){
      return {
        errors: null,
        start: false,
        find_email: "",
        errMessage: ""
      }
    },
    methods: {
      mail_pwd(){
        this.validator.validateAll({
          find_email: this.find_email,
        }).then(result => {
          let Pwd1Info = {
            email: this.find_email,
          }
          console.log(result);
          if (result) {
            forgetPwd(Pwd1Info).then(result => {
              console.log(result);
              if (result.code == 1) {
                this.$message({
                  message: 'ヘルプページをメールアドレスに発送完了',
                  type: 'success'
                });
//                this.$router.push({name: "updatePwd"})
              }
            }).catch(err => {
              if (err.code == 5) {
                this.errMessage = "ユーザIDの入力に誤りがあるか登録されていません";
              } else if (err.code == 17) {
                this.errMessage = err.message;
              }
            })
          }
        })
      }
    },
    components: {},
    created(){
      this.validator = new Validator({});  // 初始化Validator对象
      Validator.extend('find_email', {
        getMessage: field => '正しいメールアドレスを入力してください',
        validate: value => /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)  // 验证条件
      });
      Validator.extend('login_pwd', {
        getMessage: field => '入力内容が正しくありません',
        validate: value => /(?=.*[a-zA-Z])(?=.*[\d])[\w\W]{6,20}/.test(value)  // 验证条件
      });
      this.validator.attach({name: 'find_email', rules: 'required|find_email|', alias: 'メールアドレス'});
      this.validator.attach({name: 'find_code', rules: 'required', alias: '検証コード'});
      this.$set(this, 'errors', this.validator.errors);
    },
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: 0px) and(max-width: 749px) {
    .find_pwd {
      width: 100%;
      letter-spacing: $letter;
      input {
        border: none;
        outline: none;
      }
      .f_pwd_xuan {
        display: none;
      }
      .p_pwd_xuan {
        height: 40px;
        line-height: 40px;
        background-color: $TitColor;
        width: 100%;
        color: white;
        display: flex;
        font-size: 16/$default-w+rem;
        justify-content: space-between;
        span:nth-child(1),
        span:nth-child(3) {
          height: 30px;
          width: 30px;
          margin-left: 7.5px;
        }
        img {
          margin-top: 5px;
        }
      }
      .find_pwd_input {
        height: 35px;
        width: 286px;
        border: 1px solid $fontColor;
        margin: 0 auto;
        margin-top: 100px;
        border-radius: 5px;
        background-color: white;
        input {
          height: 34px;
          width: 280px;
          margin-left: 6px;
          border-radius: 5px;
        }
        .error {
          color: red;
          font-size: 12px;
          margin-top: 5px;
        }
      }
      .find_pwd_down {
        width: 286px;
        height: 40px;
        margin: 0 auto;
        margin-top: 50px;
        border-radius: 5px;
        button {
          border-radius: 5px;
          height: 100%;
          width: 100%;
          border: none;
          outline: none;
          background-color: #595758;
          color: $whiteColor;
        }
      }
    }
  }

  @media screen and(min-width: 750px) {
    .find_pwd {
      width: 100%;
      margin: 100px 0;
      letter-spacing: $letter;
      input {
        border: none;
        outline: none;
      }
      .f_pwd_xuan {
        height: 20px;
        line-height: 20px;
        width: 100%;
        text-align: center;
        span {
          color: $fontColor;
          margin-top: 20px;
          display: inline-block;
          height: 25px;
          /*<!--border-bottom: 1px solid $fontColor;-->*/
          text-align: center;
        }
      }
      .p_pwd_xuan {
        display: none;
      }
      .find_pwd_input {
        height: 35px;
        width: 286px;
        border: 1px solid $fontColor;
        margin: 0 auto;
        margin-top: 100px;
        border-radius: 5px;
        background-color: white;
        input {
          height: 34px;
          width: 280px;
          margin-left: 6px;
          border-radius: 5px;
        }
        .error {
          color: red;
          font-size: 12px;
          margin-top: 5px;
        }
      }
      .find_pwd_down {
        width: 286px;
        height: 40px;
        margin: 0 auto;
        margin-top: 50px;
        border-radius: 5px;
        button {
          border-radius: 5px;
          height: 100%;
          width: 100%;
          border: none;
          outline: none;
          background-color: #595758;
          color: $whiteColor;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/users/forgetPwd.vue